import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { EquipmentModel } from 'types/api'
import { BaseParams } from 'types/utils'

export function usePatchEquipment() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()

  async function patchEquipment({
    id,
    body
  }: BaseParams<EquipmentModel, 'PATCH'>) {
    const response = await apiClient.patch(
      SNA_PREFIX + `equipments/${id}/`,
      body
    )
    return response.data
  }

  return useMutation({
    mutationFn: patchEquipment,
    onSuccess: () => {
      toast.success({ message: t('equipmentUpdated') })
      queryClient.invalidateQueries({ queryKey: ['equipment'] })
    },
    onError: () => {
      toast.error({ message: t('equipmentUpdateError') })
    }
  })
}
